<template>
	<div class="product-table">
		<div class="product-table__small-title"  style="clear: both;">
			Inserts:
		</div>
		
		<div style="clear: both;">
			<div v-for="(eachinsert, sku) in packingData.insert" :key="sku" class="packing">
				
				<img :src="'https://new.colorwayrb.com/backend/packingicons/' +  eachinsert.icon  ">
				
				<div style="margin-top: -40px ; position: relative; font-size: 30px; text-align: right;">
				X {{ eachinsert.qty }}
				</div>
				
			</div>
		
		</div>
		
		<div class="product-table__small-title"  style="clear: both;">
			Bags:
		</div >
		
		<div style="clear: both;" >
			<div v-for="(eachbag, sku) in packingData.bags" :key="sku"  class="packing">
				<img :src="'https://new.colorwayrb.com/backend/packingicons/' +  eachbag.icon  ">
				<div style="margin-top: -40px ; position: relative; font-size: 30px; text-align: right;">
				X {{ eachbag.qty }}
				</div>
			</div>
		
		</div>
		
	</div>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
	name: "",
	components: {},
	computed: {
		packingData: {
			get() {
				return this.$store.getters.packingInfo;
			}
		}
	},
	method: {
		getImgUrl(pic) {
			return require(`@/assets/images/${pic}`);
		}
	}
});
</script>

<style lang="scss" scoped>
.product-table {
	padding: 0 0 40px;

	&__small-title {
		text-align: center;
		padding: 10px 0 20px;
		font-weight: 600;
		font-size: 14px;
	}

	&__table {
		margin: 0 auto;

		th,
		td {
			border: 1px solid $border-color;
			text-align: center;
			padding: 7px 0;
			font-size: 14px;
		}

		th {
			background-color: lighten($color7, 10%);
			font-weight: 500;
			width: 140px;
		}

		td {
			background-color: $table-light-bg;
		}
	}
}

.packing {
	
	float: left;
	width: 200px;
	height: 200px;
	
}
</style>